// import { useState } from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
//   Alert,
//   Spinner,
// } from "react-bootstrap";
// import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css";
// import "./forms.css";
// import axios from "axios";
// import ReCAPTCHA from "react-google-recaptcha";
// import {
//   APP_GTAG_CONVERSION_ID,
//   APP_RECAPTCHA_SITE_KEY,
// } from "../../utils/env";
// import { useScroll } from "../../context/scroll-context";
// import { useAcubeService } from "../../service/acube-api.hook";
// const ContactForm = () => {
//   const [selectedOption, setSelectedOption] = useState("");
//   const [recapVal, setRecapVal] = useState(null);
//   const [formValues, setFormValues] = useState({
//     name: "",
//     company: "",
//     email: "",
//     phone: "",
//     message: "",
//   });
//   const [errors, setErrors] = useState({});
//   const [successMessage, setSuccessMessage] = useState("");
//   const [errorMessage, setErrorMessage] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const { postProxy } = useAcubeService();
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormValues({ ...formValues, [name]: value });
//     // Clear the error for the current field
//     if (errors[name]) {
//       clearError(name);
//     }
//   };
//   const handlePhoneChange = (value) => {
//     setFormValues({ ...formValues, phone: value });
//     // Clear the phone error
//     clearError("phone");
//   };
//   const handleSelectChange = (e) => {
//     const { value } = e.target;
//     setSelectedOption(value);
//     // Clear the selectedOption error
//     if (errors.selectedOption) {
//       clearError("selectedOption");
//     }
//   };
//   const validateForm = () => {
//     const newErrors = {};
//     if (!formValues.name) newErrors.name = "Name is required";
//     if (!formValues.company) newErrors.company = "Company is required";
//     if (!formValues.email) newErrors.email = "Email is required";
//     if (!formValues.phone) newErrors.phone = "Phone number is required";
//     if (!selectedOption) newErrors.selectedOption = "Please select an option";
//     if (!recapVal) newErrors.recaptcha = "Please complete the reCAPTCHA";
//     // Email validation using regex
//     const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (formValues.email && !emailPattern.test(formValues.email)) {
//       newErrors.email = "Please enter a valid email address";
//     }
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };
//   const sendEmail = async () => {
//     const params = {
//       name: formValues.name,
//       company_name: formValues.company,
//       email: formValues.email,
//       phone: formValues.phone,
//       lookingfor: selectedOption,
//       message: formValues.message,
//       type: "trial",
//     };
//     await postProxy("contact/get-touch", params)
//       .then(() => {
//         setSuccessMessage(
//           "Thank you for reaching out! Your message has been sent successfully."
//         );
//         setErrorMessage("");
//         setIsLoading(false);
//         if (window.gtag) {
//           window.gtag("event", "conversion", {
//             send_to: APP_GTAG_CONVERSION_ID + "/Mw06CIGEnIwYEOeYrKQp",
//             event_category: "User",
//             event_action: "Form Submission",
//             event_label: "Form Button Click",
//           });
//         }
//         setTimeout(() => {
//           setSuccessMessage("");
//           setFormValues({
//             name: "",
//             company: "",
//             email: "",
//             phone: "",
//             message: "",
//           });
//           setSelectedOption("");
//         }, 5000);
//       })
//       .catch((error) => {
//         console.error("There was an error sending the email:", error);
//         setSuccessMessage("");
//         setErrorMessage(
//           "Oops! Something went wrong while sending your message. Please try again later."
//         );
//         setIsLoading(false);
//       });
//   };
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (validateForm()) {
//       setIsLoading(true);
//       sendEmail();
//     } else {
//       setSuccessMessage("");
//       setErrorMessage(
//         "Please make sure all required fields are filled out correctly before submitting the form."
//       );
//       setIsLoading(false);
//     }
//   };
//   const clearError = (field) => {
//     // Remove the specific error field
//     if (errors[field]) {
//       setErrors((prevErrors) => {
//         const newErrors = { ...prevErrors, [field]: null };
//         // Check if there are any remaining errors after clearing the current one
//         const hasRemainingErrors = Object.values(newErrors).some(
//           (error) => error !== null
//         );
//         if (!hasRemainingErrors) {
//           setErrorMessage("");
//         }
//         return newErrors;
//       });
//     }
//   };
//   const { contactform } = useScroll();

//   return (
//     <section className="contact-form-section py-5" id="section1">
//       <Container fluid>
//         <h2 className="text-center mb-3 text-primary ft-wt-600 text-uppercase mx-auto" ref={contactform} style={{ maxWidth: "1200px" }}>
//           Let’s Talk! Book a free consultation
//         </h2>
//         <h3 className="text-center mb-5 text-primary mx-auto ft-28 ft-wt-400" style={{ maxWidth: "1200px" }}>
//           Find Your Ideal Developer – <span className="ft-wt-600">2 Weeks Free!</span>
//         </h3>
//         {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
//         {successMessage && <Alert variant="success">{successMessage}</Alert>}
//         <Form onSubmit={handleSubmit} id="footer-contact-form" noValidate>
//           <Row className="mb-30 gap-4 gap-lg-0">
//             <Col xs="12" lg="4">
//               <Form.Group controlId="formName" className="position-relative">
//                 <Form.Control
//                   type="text"
//                   placeholder="Name"
//                   name="name"
//                   value={formValues.name}
//                   onChange={handleInputChange}
//                   isInvalid={!!errors.name}
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.name}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//             <Col xs="12" lg="4">
//               <Form.Group controlId="formCompany" className="position-relative">
//                 <Form.Control
//                   type="text"
//                   placeholder="Company / Organization"
//                   name="company"
//                   value={formValues.company}
//                   onChange={handleInputChange}
//                   isInvalid={!!errors.company}
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.company}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//             <Col xs="12" lg="4">
//               <Form.Group controlId="formEmail" className="position-relative">
//                 <Form.Control
//                   type="email"
//                   placeholder="Company Email ID"
//                   name="email"
//                   value={formValues.email}
//                   onChange={handleInputChange}
//                   isInvalid={!!errors.email}
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.email}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//           </Row>
//           <Row className="mb-3 gap-4 gap-lg-0">
//             <Col xs="12" lg="4">
//               <Form.Group controlId="formSelect" className="position-relative">
//                 <Form.Control
//                   aria-label="How can we help you?"
//                   as="select"
//                   value={selectedOption}
//                   onChange={handleSelectChange}
//                   isInvalid={!!errors.selectedOption}
//                 >
//                   <option value="" disabled hidden>
//                     How Can We Help You?
//                   </option>
//                   <option value="Mobile app development">
//                     Mobile app development
//                   </option>
//                   <option value="UI/UX Design">UI/UX Design</option>
//                   <option value="Android app development">
//                     Android app development
//                   </option>
//                   <option value="IOS app development">
//                     IOS app development
//                   </option>
//                   <option value="Web app development">
//                     Web app development
//                   </option>
//                   <option value="IOT">IOT</option>
//                   <option value="AIML">AIML</option>
//                   <option value="QA Automation">QA Automation</option>
//                   <option value="RPA">RPA</option>
//                   <option value="Others">Others</option>
//                 </Form.Control>
//                 <Form.Control.Feedback type="invalid">
//                   {errors.selectedOption}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//             <Col xs="12" lg="4">
//               <Form.Group controlId="formPhone" className="position-relative">
//                 <PhoneInput
//                   country={"us"}
//                   inputProps={{
//                     name: "phone",
//                     required: true,
//                     autoFocus: false,
//                   }}
//                   placeholder="Mobile Number*"
//                   value={formValues.phone}
//                   onChange={handlePhoneChange}
//                   isInvalid={!!errors.phone}
//                 />
//                 {errors.phone && (
//                   <div className="text-danger position-absolute d-block ft-12 phone-error">
//                     {errors.phone}
//                   </div>
//                 )}
//               </Form.Group>
//             </Col>
//             <Col xs="12" lg="4">
//               <Form.Group controlId="formMessage">
//                 <Form.Control
//                   as="textarea"
//                   rows={3}
//                   placeholder="Share Your Message"
//                   name="message"
//                   value={formValues.message}
//                   onChange={handleInputChange}
//                 />
//               </Form.Group>
//             </Col>
//           </Row>
//           <div className="text-center d-flex flex-column gap-4 align-items-center">
//             <ReCAPTCHA
//               sitekey={APP_RECAPTCHA_SITE_KEY}
//               onChange={(val) => setRecapVal(val)}
//             />
//             {errors.recaptcha && (
//               <div className="text-danger mt-2">{errors.recaptcha}</div>
//             )}
//             <Button
//               variant="primary"
//               type="submit"
//               className="text-uppercase gap-2 d-flex align-items-center"
//               disabled={!recapVal}
//             >
//               {isLoading && <Spinner size="sm" />}
//               Get Started
//             </Button>
//           </div>
//         </Form>
//       </Container>
//     </section>
//   );
// };
// export default ContactForm;


import { useState } from "react";
import { Container, Row, Col, Form, Button, Alert, Spinner } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./forms.css";
import { useScroll } from "../../context/scroll-context";
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useAcubeService } from "../../service/acube-api.hook";
import { APP_RECAPTCHA_SITE_KEY } from "../../utils/env";

const ContactFormInner = () => {
  const [selectedOption, setSelectedOption] = useState("");
  const [formValues, setFormValues] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();

  // Using environment variables safely
  const APP_GTAG_CONVERSION_ID = import.meta.env.VITE_GTAG_CONVERSION_ID;
  const { postProxy } = useAcubeService();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    // Clear the error for the current field
    if (errors[name]) {
      clearError(name);
    }
  };

  const handlePhoneChange = (value) => {
    setFormValues({ ...formValues, phone: value });
    // Clear the phone error
    clearError("phone");
  };

  const handleSelectChange = (e) => {
    const { value } = e.target;
    setSelectedOption(value);
    // Clear the selectedOption error
    if (errors.selectedOption) {
      clearError("selectedOption");
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formValues.name) newErrors.name = "Name is required";
    if (!formValues.company) newErrors.company = "Company is required";
    if (!formValues.email) newErrors.email = "Email is required";
    if (!formValues.phone) newErrors.phone = "Phone number is required";
    if (!selectedOption) newErrors.selectedOption = "Please select an option";

    // Email validation using regex
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formValues.email && !emailPattern.test(formValues.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const sendEmail = async () => {
    const params = {
      name: formValues.name,
      company_name: formValues.company,
      email: formValues.email,
      phone: formValues.phone,
      lookingfor: selectedOption,
      message: formValues.message,
      type: "trial",
    };

    await postProxy("contact/get-touch", params)
      .then(() => {
        setSuccessMessage(
          "Thank you for reaching out! Your message has been sent successfully."
        );
        setErrorMessage("");
        setIsLoading(false);

        if (window.gtag && APP_GTAG_CONVERSION_ID) {
          window.gtag("event", "conversion", {
            send_to: APP_GTAG_CONVERSION_ID + "/Mw06CIGEnIwYEOeYrKQp",
            event_category: "User",
            event_action: "Form Submission",
            event_label: "Form Button Click",
          });
        }

        setTimeout(() => {
          setSuccessMessage("");
          setFormValues({
            name: "",
            company: "",
            email: "",
            phone: "",
            message: "",
          });
          setSelectedOption("");
        }, 5000);
      })
      .catch((error) => {
        console.error("There was an error sending the email:", error);
        setSuccessMessage("");
        setErrorMessage(
          "Oops! Something went wrong while sending your message. Please try again later."
        );
        setIsLoading(false);
      });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsLoading(true);

      let token = null;

      if (executeRecaptcha) {
        try {
          token = await executeRecaptcha('contact_form');
          if (!token) {
            setErrorMessage(
              "reCAPTCHA token is missing. Please refresh the page and try again."
            );
          } else {
            sendEmail();
          }
        } catch (recaptchaError) {
          setErrorMessage(
            "reCAPTCHA execution failed. Please refresh the page and try again."
          );
        }
      } else {
        setErrorMessage(
          "reCAPTCHA execution failed. Please refresh the page and try again."
        );
      }


    } else {
      setSuccessMessage("");
      setErrorMessage(
        "Please make sure all required fields are filled out correctly before submitting the form."
      );
      setIsLoading(false);
    }
  };

  const clearError = (field) => {
    // Remove the specific error field
    if (errors[field]) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors, [field]: null };
        // Check if there are any remaining errors after clearing the current one
        const hasRemainingErrors = Object.values(newErrors).some(
          (error) => error !== null
        );
        if (!hasRemainingErrors) {
          setErrorMessage("");
        }
        return newErrors;
      });
    }
  };

  const { contactform } = useScroll();

  return (
    <section className="contact-form-section py-5" id="section1">
      <Container fluid>
        <h2 className="text-center mb-3 text-primary ft-wt-600 text-uppercase mx-auto" ref={contactform} style={{ maxWidth: "1200px" }}>
          Let's Talk! Book a free consultation
        </h2>
        <h3 className="text-center mb-5 text-primary mx-auto ft-28 ft-wt-400" style={{ maxWidth: "1200px" }}>
          Find Your Ideal Developer – <span className="ft-wt-600">2 Weeks Free!</span>
        </h3>
        {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
        {successMessage && <Alert variant="success">{successMessage}</Alert>}
        <Form onSubmit={handleSubmit} id="footer-contact-form" noValidate>
          <Row className="mb-30 gap-4 gap-lg-0">
            <Col xs="12" lg="4">
              <Form.Group controlId="formName" className="position-relative">
                <Form.Control
                  type="text"
                  placeholder="Name"
                  name="name"
                  value={formValues.name}
                  onChange={handleInputChange}
                  isInvalid={!!errors.name}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs="12" lg="4">
              <Form.Group controlId="formCompany" className="position-relative">
                <Form.Control
                  type="text"
                  placeholder="Company / Organization"
                  name="company"
                  value={formValues.company}
                  onChange={handleInputChange}
                  isInvalid={!!errors.company}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.company}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs="12" lg="4">
              <Form.Group controlId="formEmail" className="position-relative">
                <Form.Control
                  type="email"
                  placeholder="Company Email ID"
                  name="email"
                  value={formValues.email}
                  onChange={handleInputChange}
                  isInvalid={!!errors.email}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3 gap-4 gap-lg-0">
            <Col xs="12" lg="4">
              <Form.Group controlId="formSelect" className="position-relative">
                <Form.Control
                  aria-label="How can we help you?"
                  as="select"
                  value={selectedOption}
                  onChange={handleSelectChange}
                  isInvalid={!!errors.selectedOption}
                >
                  <option value="" disabled hidden>
                    How Can We Help You?
                  </option>
                  <option value="Mobile app development">
                    Mobile app development
                  </option>
                  <option value="UI/UX Design">UI/UX Design</option>
                  <option value="Android app development">
                    Android app development
                  </option>
                  <option value="IOS app development">
                    IOS app development
                  </option>
                  <option value="Web app development">
                    Web app development
                  </option>
                  <option value="IOT">IOT</option>
                  <option value="AIML">AIML</option>
                  <option value="QA Automation">QA Automation</option>
                  <option value="RPA">RPA</option>
                  <option value="Others">Others</option>
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {errors.selectedOption}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs="12" lg="4">
              <Form.Group controlId="formPhone" className="position-relative">
                <PhoneInput
                  country={"us"}
                  inputProps={{
                    name: "phone",
                    required: true,
                    autoFocus: false,
                  }}
                  placeholder="Mobile Number*"
                  value={formValues.phone}
                  onChange={handlePhoneChange}
                  isInvalid={!!errors.phone}
                />
                {errors.phone && (
                  <div className="text-danger position-absolute d-block ft-12 phone-error">
                    {errors.phone}
                  </div>
                )}
              </Form.Group>
            </Col>
            <Col xs="12" lg="4">
              <Form.Group controlId="formMessage">
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Share Your Message"
                  name="message"
                  value={formValues.message}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <div className="text-center d-flex flex-column gap-4 align-items-center">
            <Button
              variant="primary"
              type="submit"
              className="text-uppercase gap-2 d-flex align-items-center"
            >
              {isLoading && <Spinner size="sm" />}
              Get Started
            </Button>
          </div>
        </Form>
      </Container>
    </section>
  );
};

const ContactForm = () => {

  return (
    <GoogleReCaptchaProvider reCaptchaKey={APP_RECAPTCHA_SITE_KEY}>
      <ContactFormInner />
    </GoogleReCaptchaProvider>
  );
};

export default ContactForm;
